import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { ViewTransitionTypes, viewTransition } from "@/utils/view-transitions";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/activity",
)({
	component: RouteComponent,
	beforeLoad: ({ params, location }) => {
		// Check if we're at the exact activity path (not a child route)
		const activityPath = `/org-admin/${params.orgId}/activity`;
		if (
			location.pathname === activityPath ||
			location.pathname === `${activityPath}/`
		) {
			throw redirect({
				to: "/org-admin/$orgId/activity/logs",
				params: {
					orgId: params.orgId,
				},
				replace: true,
				...viewTransition(ViewTransitionTypes.FADE),
			});
		}
	},
});

function RouteComponent() {
	return <Outlet />;
}
